import React from 'react';

import { TOCSidebar } from '@/modules/core/components/TOCSidebar/TOCSidebar';
import { useDetectActiveTOCModule } from '@/modules/core/hooks/useDetectActiveTOCModule';
import { useTOCConfiguration } from '@/modules/employer/hooks/useTOCConfiguration';

const EmployerTOCSidebar: React.FC = () => {
  const config = useTOCConfiguration();
  const { scrollToSection } = useDetectActiveTOCModule(config);
  return <TOCSidebar stepsMap={config} scrollToSection={scrollToSection} />;
};

export default EmployerTOCSidebar;
